import React, { useEffect, useState } from "react";
import { getAllSuggestions } from "../../api/suggestions";

/**
 * SuggestionPicker — recherche une suggestion existante (par terme ou
 * auteur) et capture son sugId, pour relier une fiche à la suggestion dont
 * elle est issue (nécessaire pour l'historique : "qui l'a proposée").
 *
 * Usage :
 *   <SuggestionPicker value={form.ficSugId} onChange={(sugId) => setForm(f => ({ ...f, ficSugId: sugId }))} />
 */
export default function SuggestionPicker({ value, onChange }) {
  const [all, setAll] = useState([]);
  const [query, setQuery] = useState("");
  const [open, setOpen] = useState(false);

  useEffect(() => {
    getAllSuggestions()
      .then((data) => setAll(Array.isArray(data) ? data : []))
      .catch((e) => console.error("Erreur chargement suggestions", e));
  }, []);

  const selected = all.find((s) => String(s.sugId) === String(value));

  const matches =
    query.trim().length >= 2
      ? all
          .filter(
            (s) =>
              (s.terme || "").toLowerCase().includes(query.toLowerCase()) ||
              (s.auteur || "").toLowerCase().includes(query.toLowerCase())
          )
          .slice(0, 8)
      : [];

  if (selected) {
    return (
      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
        <span
          style={{
            background: "#dbeafe",
            color: "#1e40af",
            border: "1px solid #93c5fd",
            borderRadius: 20,
            padding: "3px 10px",
            fontSize: 13,
            fontWeight: 500,
          }}
        >
          {selected.terme}
          {selected.auteur ? ` — ${selected.auteur}` : ""}
        </span>
        <button
          type="button"
          onClick={() => onChange(null)}
          title="Retirer le lien vers cette suggestion"
          style={{ background: "none", border: "none", cursor: "pointer", color: "#1e40af", fontWeight: "bold" }}
        >
          ✕
        </button>
      </div>
    );
  }

  return (
    <div style={{ position: "relative" }}>
      <input
        type="text"
        placeholder="Rechercher une suggestion par terme ou auteur..."
        value={query}
        onChange={(e) => {
          setQuery(e.target.value);
          setOpen(true);
        }}
        onFocus={() => setOpen(true)}
        onBlur={() => setTimeout(() => setOpen(false), 150)}
        style={{ width: "100%", padding: "8px 10px", border: "1px solid #ddd", borderBottom: "2px solid rgb(58,58,58)", boxSizing: "border-box" }}
      />
      {open && matches.length > 0 && (
        <ul
          style={{
            position: "absolute",
            zIndex: 1000,
            background: "#fff",
            border: "1px solid #ccc",
            borderTop: "none",
            width: "100%",
            listStyle: "none",
            margin: 0,
            padding: 0,
            maxHeight: 240,
            overflowY: "auto",
          }}
        >
          {matches.map((s) => (
            <li
              key={s.sugId}
              onMouseDown={() => {
                onChange(s.sugId);
                setQuery("");
                setOpen(false);
              }}
              style={{ padding: "6px 10px", cursor: "pointer", borderBottom: "1px solid #f0f0f0", fontSize: 13 }}
            >
              <strong>{s.terme}</strong>
              {s.auteur ? ` — ${s.auteur}` : ""}
              {s.date ? ` (${s.date})` : ""}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
